import { Box, CheckBox, ModBox, Spacer, Text } from '@jfs/ui-new'
import { FC, useState } from 'react'
import ReactDOM from 'react-dom'
import { FlatList, ScrollView, useWindowDimensions } from 'react-native'
import { SelectParentEntityList } from '../../screens/EntityManagement/Onboarding/CreateEntity/SelectParentEntityList'
import styles from './styles'

interface ModalViewProps {
  hide?: boolean
  type?: string
  onDismiss: () => void
  selectedData?: (values: any) => void
  measureInfo?: any
  data?: any
  preSelectedData?: any
  isMultiSelect?: boolean
  fullWidthContent?: boolean
  horizontalScroll?: boolean
  separateDataAndDropdown?: boolean
  parentType: 'default' | 'table'
  tableData?: any[]
  tableColumnMapper?: any
  tableHeaderTitles?: any[]
  onTableItemPress?: (data: any) => void
  passFullItemOnSelection?: boolean
  dataFieldToRead?: string
}

const ModalView: FC<ModalViewProps> = ({
  hide,
  onDismiss,
  selectedData,
  measureInfo,
  data,
  preSelectedData = [],
  isMultiSelect = false,
  fullWidthContent = false,
  horizontalScroll,
  separateDataAndDropdown = false,
  parentType = 'default',
  tableData,
  tableColumnMapper,
  tableHeaderTitles,
  onTableItemPress,
  passFullItemOnSelection,
  dataFieldToRead = 'value',
}: ModalViewProps) => {
  // console.log('ModalView tableData: ', tableData)

  const [selectionData, setSelectionData] = useState(preSelectedData as Array<any>)
  const [dropdownHeight, setDropdownHeight] = useState(0)

  const screenHeight = useWindowDimensions()?.height

  if (!hide) {
    return null
  }

  const handleCheckBox = (listItem: any) => {
    if (!isMultiSelect && selectedData) {
      selectedData(passFullItemOnSelection ? listItem : [listItem?.[dataFieldToRead]])
      onDismiss()
      return
    }
    let inputInfoId = listItem.value
    let selectedArray = selectionData
    if (selectedArray?.includes(inputInfoId)) {
      var index = selectedArray.indexOf(inputInfoId)
      selectedArray.splice(index, 1)
    } else {
      selectedArray = selectedArray?.length === 0 ? [inputInfoId] : [...selectedArray, inputInfoId]
    }
    setSelectionData([...selectedArray])
  }

  const renderItem = ({ item }: { item: any }) => {
    const isChecked = selectionData?.includes(item?.value)
    return (
      <Box {...styles.itemView} onPress={() => handleCheckBox(item)} testID={`dropdown-item-${item?.value}`}>
        {isMultiSelect && (
          <>
            <CheckBox color={'PRIMARY'} checked={isChecked} onChange={() => handleCheckBox(item)} />
            <Spacer direction="horizontal" size={8} />
          </>
        )}
        <Box flexWrap={'wrap'} width={'100%'}>
          <Text
            color={'BLACK_21'}
            fontFamily={'jiotype-medium'}
            fontWeight={'400'}
            numberOfLines={2}
            fontSize={12}
            title={item?.[dataFieldToRead]}
          />
        </Box>
      </Box>
    )
  }
  const getKeyExtractor = (itemData: any, index: number): string => {
    return `${itemData?.fileName}_${index}`
  }
  const seperator = ({ section }: { section: any }) => {
    return <Box w={'100%'} h={1} bg="LIGHTEST_GREY" />
  }

  const applyClicked = () => {
    if (selectedData) {
      console.log('🚀 ~ file: index.tsx ~ line 62 ~ applyClicked ~ selectedFileData', selectedData)
      selectedData(selectionData)
    }
    onDismiss()
  }

  const cancelClicked = () => {
    onDismiss()
  }

  const onTableRowPress = (data: any) => {
    onTableItemPress && onTableItemPress(data)
    onDismiss()
  }

  let top = measureInfo.top
  const width = measureInfo?.width
  top = screenHeight - top > dropdownHeight ? top - 8 : top - dropdownHeight - 52
  const dropdownList = () => {
    console.log('parentType', parentType, data)
    return (
      <Box {...styles.container} marginTop={separateDataAndDropdown ? 1 : 0} onPress={onDismiss}>
        <Box
          {...styles.contentViewStyle(fullWidthContent, width)}
          top={top}
          left={measureInfo.left}
          onLayout={(evt: any) => setDropdownHeight(evt?.nativeEvent?.layout?.height)}>
          <ScrollView horizontal={horizontalScroll ? true : false} contentContainerStyle={styles.contentContainerStyle}>
            <ModBox show={parentType === 'default' && data?.length > 0} overflow={'auto'}>
              <FlatList
                nativeID="vertical-scroll"
                ItemSeparatorComponent={seperator}
                keyExtractor={getKeyExtractor}
                data={data}
                style={styles.flatlistStyle(measureInfo?.width)}
                scrollEnabled
                renderItem={renderItem}
              />
            </ModBox>
            <ModBox show={parentType === 'table'} w={width} overflow={'auto'} maxHeight={230}>
              <SelectParentEntityList
                nativeID="vertical-scroll"
                title={''}
                hide={false}
                data={tableData ?? []}
                columnFlexMapper={tableColumnMapper}
                headerTitles={tableHeaderTitles ?? []}
                onItemPress={onTableRowPress}
                minHeight={230}
              />
            </ModBox>
          </ScrollView>
          {isMultiSelect && (
            <Box flexDirection={'row'} align="center" padding={16}>
              <Box {...styles.apply} onPress={applyClicked}>
                <Text type="caption2" weight="dense" color="WHITE">
                  {'Apply'}
                </Text>
              </Box>
              <Spacer direction="horizontal" size={16} />
              <Box {...styles.cancel} onPress={cancelClicked}>
                <Text type="caption2" weight="dense" color="BLACK_75">
                  {'Cancel'}
                </Text>
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    )
  }

  return ReactDOM.createPortal(dropdownList(), document.body)
}

export { ModalView }
